import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import lodash from 'lodash'

import TimeRangePicker from '../../../../1stlog-ui/src/components/TimeRangePicker'
import Checkbox from '../../../../1stlog-ui/src/components/Checkbox'
import Button from '../../../../1stlog-ui/src/components/Button'
import DatePicker from '../../../../1stlog-ui/src/components/DatePicker'
import RadioSelect from '../../../../1stlog-ui/src/components/RadioSelect'
import Card from 'components/Card'
import Field, { required } from 'components/Field'
import SlaSelect from './SlaSelect'
import SortSelect from './SortSelect'

const Form = (props) => {
  const { form, getFormApi } = props
  useEffect(() => {
    getFormApi(form)
    const values = props.initialValues

    form.batch(() => {
      lodash.forEach(values, (value, key) => form.change(key, value))
    })
  }, [])

  const dateOptions = [
    { value: 'shipping', label: i18n.t('shippingDate', 'Versanddatum') },
    { value: 'coverage', label: i18n.t('coverageDate', 'Erfassungsdatum') },
  ]
  return (
    <Row className="mt-4">
      <Col md={{ span: 12, offset: 0 }}>
        <div>
          <Card badge="1" notoggle noHeader>
            <Row>
              <Col md="4">
                <Field
                  name="dateType"
                  label={i18n.t('shippingDate_coverageDate', 'Versanddatum / Erfassungsdatum')}
                >
                  <RadioSelect inline spacing={'0.50em'} options={dateOptions} />
                </Field>
              </Col>
              <Col md="4">
                <SlaSelect />
              </Col>
              <Col md="4">
                <SortSelect />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="d-flex">
                  <div>
                    <Field name="date" label={i18n.t('date', 'Datum')} required validate={required}>
                      <DatePicker nodisabled autoclose />
                    </Field>
                    <Field name="restrictTime">
                      <Checkbox>{i18n.t('restrict_time_range', 'Zeitraum einschränken')}</Checkbox>
                    </Field>
                  </div>
                  <div className="ml-2">
                    <Field name="restrictTime" isSpy>
                      {(restrictTime) =>
                        restrictTime && (
                          <Field name="timerange" label={i18n.t('time_range', 'Zeitraum')}>
                            <TimeRangePicker />
                          </Field>
                        )
                      }
                    </Field>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
          <div className="d-flex justify-content-end">
            <Button onClick={form.submit} dark>
              <i className={'far fa-print'} />
              &nbsp; {i18n.t('print', 'Drucken')}
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default Form

export const stringifyValues = (values) => {
  if (!values) return { date: null, slas: [] }

  return {
    ...values,
    slas: values.slas ? values.slas : [],
  }
}
